export default __webpack_public_path__ + "static/media/vip2.158c481b.webp";